import React, { useState } from "react";
import PhoneEnabledIcon from "@mui/icons-material/PhoneEnabled";
import EmailIcon from "@mui/icons-material/Email";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import MarkAsUnreadIcon from "@mui/icons-material/MarkAsUnread";

// import JS files
import Navbar from "../shares/others/Navbar";
import Footer from "../shares/others/Footer";
import Breadcrumb from "../shares/others/Breadcrumb";
import Header from "../shares/others/Header";

// import others files
import telegramIcon from "../../assets/imgs/telegram.svg";
import twitterIcon from "../../assets/imgs/twitter.svg";
import instagramIcon from "../../assets/imgs/instagram.svg";

const breadcrumbList = ["صفحه اصلی", "تماس با ما"];

const ContactUs = (props) => {
  return (
    <>
      <Navbar active_item="contactus" />
      <div className="mx-8 2xl:mx-32 mt-8 mb-20">
        <Breadcrumb list={breadcrumbList} />
        <div className="my-6">
          <Header header="تماس با ما" noAllItems />
          <div className="grid md:grid-cols-3 gap-4 md:gap-12 mt-8">
            <div className="bg-mygrays-100 p-4 rounded-lg flex justify-between items-center text-myblacks-200">
              <div>
                <PhoneEnabledIcon />
                <span className="mr-4">شماره تماس:</span>
              </div>
              <span>۰۲۱-۷۵۳۳۱۶۵۰</span>
            </div>
            <div className="bg-mygrays-100 p-4 rounded-lg flex justify-between items-center text-myblacks-200">
              <div>
                <EmailIcon />
                <span className="mr-4">ایمیل:</span>
              </div>
              <span>info@moraghebbime.ir</span>
            </div>
            <div className="bg-mygrays-100 p-4 rounded-lg flex justify-between items-center text-myblacks-200">
              <span>ما را دنبال کنید:</span>
              <div className="flex items-center">
                <a
                  target="_blank"
                  href="https://instagram.com/moraghebbime?igshid=ODkwYmMyNzQ1NA=="
                >
                  <img
                    className="w-6 md:w-8 mr-4 transition-all hover:scale-125 cursor-pointer"
                    src={instagramIcon}
                  />
                </a>
                <a target="_blank" href="https://t.me/moraghebbime">
                  <img
                    className="w-6 md:w-8 mr-4 transition-all hover:scale-125 cursor-pointer"
                    src={telegramIcon}
                  />
                </a>
                <a>
                  <img
                    className="w-6 md:w-8 mr-4 transition-all hover:scale-125 cursor-pointer"
                    src={twitterIcon}
                  />
                </a>
              </div>
            </div>
          </div>
          <div className="mt-12 bg-mygrays-100 p-4 rounded-lg flex flex-col md:flex-row justify-between text-myblacks-200 gap-4">
            <div className="md:basis-1/2">
              <iframe
                className="w-full h-60 md:h-full rounded-lg"
                src="https://map.ir/lat/35.725021/lng/51.405020/z/15/p/ما اینجا هستیم"
              />
            </div>
            <div className="md:basis-1/2">
              <div className="flex items-center mt-4 md:mt-0">
                <LocationOnIcon />
                <span className="mr-2">آدرس:</span>
              </div>
              <div
                className="px-2 text-myblacks-300 mt-3 text-justifytext-sm md:text-base"
                style={{ lineHeight: 2 }}
              >
                <span>
                  تهران، یوسف آباد، بالاتر از میدان سلماس خیابان شهریار نبش
                  خیابان ۱۴ پلاک ۳۹
                </span>
              </div>
              <div className="flex items-center mt-4">
                <MarkAsUnreadIcon />
                <span className="mr-2">کد پستی:</span>
              </div>
              <div className="px-2 text-myblacks-300 mt-3 text-justify leading-8 text-sm md:text-base">
                <span>۱۴۳۳۶۳۴۳۳۵</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ContactUs;
